import React, { useState, useEffect } from "react";
import "../../css/style-new.css";
import "../../css/developer1.css";
import "../../css/newlogin-new.css";
import "../../css/font.css";
import Logo from "../../images/logo.jpg";
import coachLogo from "../../images/logo-giaa.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { loginurl, GOOGLECLIENTID } from '../../apis/urls';
import { relativeTimeRounding } from "moment";
import { $ } from "react-jquery-plugin";
import { Notification, Placeholder } from "rsuite";
import GoogleLoginButton from "../../common-components/GoogleLoginButton";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";



const CoachLogin = () => {


  document.body.classList.add("new-login-wrpr");

  const [uname, setUname] = useState('');
  const [pword, setPword] = useState('');
  const [unameerror, setUnameerror] = useState('');
  const [pworderror, setPworderror] = useState('');
  const [incorrect, setIncorrect] = useState('');
  const [login, setLogin] = useState(false);
  const [adminPassowrd, setAdminPassword] = useState(true);


  let navigate = useNavigate();

  useEffect(() => {

    $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');


    let storevariable = localStorage.getItem('token');
    let username = localStorage.getItem('username');
    let userid = localStorage.getItem('userid');
    let userrole = localStorage.getItem('userrole');
    let schools = localStorage.getItem('schoolid')
    let associations = localStorage.getItem('association')
    let official = localStorage.getItem('official');
    let coachid = localStorage.getItem('coachid');
    let userisrule = localStorage.getItem('userisrule');
    console.log('stvar', storevariable)
    
    if (storevariable) {

      storeCollector(storevariable, username, userid, userrole, schools, associations, official, coachid,userisrule);
      //localStorage.clear();
    }


  }, []

  );


  const storeCollector = (a_token, username, uid, urole, school, association, officials, coachid,userisrule) => {
    localStorage.setItem('token', a_token)
    localStorage.setItem('username', username)
    localStorage.setItem('userid', uid)
    localStorage.setItem('userrole', urole)
    localStorage.setItem('schoolid', school)
    localStorage.setItem('association', association)
    localStorage.setItem('official', officials)
    localStorage.setItem('coachid', coachid)
    localStorage.setItem('userisrule', userisrule)

    let store = localStorage.getItem('token');
    let role = localStorage.getItem('userrole');
    let usid = localStorage.getItem('userid');
    let schoolid = localStorage.getItem('schoolid')
    let associationid = localStorage.getItem('association');
    let official_id = localStorage.getItem('official')
    let coachId = localStorage.getItem('coachid')
    let isrules = localStorage.getItem('userisrule')
    //let ustore = localStorage.getItem('username');
    console.log("role is",role);
    console.log('auth_token', official_id)
    if (store != 'undefined' || store != null) {


      //  if (role === 'OFFICIALS_USER') {
      if(isrules === '1'){
        let path = '/select_rule/';
        navigate(path)
        localStorage.setItem('coachlogin', 'yes')
        // window.location.reload()

      }
    }

  }


  const onFormSubmit = (e) => {
    e.preventDefault()
    let error = 0;

    if (uname === '' && pword === '') {
      setUnameerror('Enter the username')

      setPworderror('Enter the Password')

      error = 1;
    } else if (uname !== '' && pword === '') {
      setUnameerror('')

      setPworderror('Enter the Password')
      error = 1;

    } else if (uname === '' && pword !== '') {
      setUnameerror('Enter the username')

      setPworderror('')
      error = 1;

    }
    else if (uname === '') {
      setUnameerror('Enter the username')
      error = 1;
    } else if (pword === '') {
      setPworderror('Enter the password')
      error = 1;
    }
    else {
      setUnameerror('')

      setPworderror('')
    }


    if (error === 0) {

      loginFunction(uname, pword, false, null);
      // const instance = axios.create({

      //   baseURL: loginurl,

      //   timeout: 1000000,

      // });

      // const data = {
      //   username: uname,
      //   password: pword
      // }

      // instance.post('', data).then((response) => {

      //   if(response.data.data.role === 'SUPERADMIN' || response.data.data.role === 'ASSOCIATION_USER'){
      //     setAdminPassword('Invalid username or password')
      //   }else{
      //     console.log('coachdata', response.data.data)
      //     storeCollector(response.data.data.accessToken, response.data.data.username, response.data.data.id, response.data.data.role, response.data.data.school, response.data.data.association, response.data.data.officials, response.data.data.coachid);
  
      //   }
      // }).catch((error) => {
      //   //console.log('error',error.response.data.message)
      //   setIncorrect(error.response.data.message)

      // });




    }

  }

  
  const handleLoginSuccess = (response) => {
    console.log('Login Success:', response);
   

    const decodedToken = jwtDecode(response.credential);
    const email = decodedToken.email;
    loginFunction(email, pword, true, response.credential);
    console.log('decodedToken', email)
  };

  const handleLoginFailure = (response) => {
    console.log('Login Failed:', response);
    // Handle login failure
  };


  const loginFunction = async (uname, pword, googlelogin, authToken) => {

    const instance = axios.create({

      baseURL: loginurl,

      timeout: 1000000,

    });

    const data = {
      username: uname,
      password: pword,
      authToken: authToken,
      googlelogin: googlelogin,
    }

    
    instance.post('', data).then((response) => {
      

      if(response.data.data.role === 'SUPERADMIN' || response.data.data.role === 'ASSOCIATION_USER' || response.data.data.userisrule == 0){
        setAdminPassword('Invalid username or password')
      }else{
        console.log('coachdata', response.data.data)
        storeCollector(response.data.data.accessToken, response.data.data.username, response.data.data.id, response.data.data.role, response.data.data.school, response.data.data.association, response.data.data.officials, response.data.data.coachid,response.data.data.userisrule);

      }
    }).catch((error) => {
      //console.log('error',error.response.data.message)
      setIncorrect(error.response.data.message)

    });

  }

  const handleForgotPasswordClick = () => {
    localStorage.setItem('forgotpasswordcoach', 1);
  };

  
  return (


  // <body className="new-login-wrpr">
 
	<div className="wrapper new-login-wrpr">

       
  
  <div className="giaa-logo text-center">
    <img src={coachLogo} width="" height="" alt="" />
  </div>




    
		<div className="login-heading text-center text-white">COACHES LOGIN</div>
    <div className="register-and-forgot mb-2">
			<div className="ifyouarenot">If this is your first time, please create an account.
      <a className="register" href="/gisa/#/registrationcoaches">Create Account</a></div>
		</div>
		<div className="login-new">
    <div class="google-login-box giaa-login">
					<h3 style={{color:'white'}}>Already have an account? Please Login</h3>
					<span style={{display:'flex'}} class="google-badge-cntnr">
          <GoogleOAuthProvider clientId={GOOGLECLIENTID}>
                <div >
                  <GoogleLoginButton 
                    onSuccess={handleLoginSuccess}
                    onFailure={handleLoginFailure}
                  />
                </div>
              </GoogleOAuthProvider>
              <span style={{marginLeft:'8px', marginTop:'6px'}}>or</span>
            </span>
				</div>
	
				<form onSubmit={(e) => { onFormSubmit(e) }} className="needs-validation" novalidate>
					<label for="uname">Username:</label>
					<div className="input-group input-group-lg mb-3">
						<div className="input-group-prepend">
						  <span className="input-group-text"><i className="icon-envelope3"></i></span>
						</div>
						<input type="text" className="form-control" value={uname} onChange={e => setUname(e.target.value)} id="uname" placeholder="Enter username" name="uname" required></input>
            <div className="valid-feedback">Valid.</div>
            <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{unameerror}</div>
          </div>
					
					<label for="pwd">Password:</label>
					<div className="input-group input-group-lg mb-3">
					  <div className="input-group-prepend">
						  <span className="input-group-text"><i className="icon-locked"></i></span>
						</div>
					  <input type="password" className="form-control" value={pword} onChange={e => setPword(e.target.value)} id="pwd" placeholder="Enter password" name="pswd" required></input>
					</div>
          <div className="valid-feedback">Valid.</div>
          <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{pworderror}</div>
          <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{incorrect}</div>
          <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{adminPassowrd}</div>
				  <div className="login-btn-wrpr ">
					
					<button type="submit" className="btn btn-primary">Login <i className="icon-keyboard_arrow_right"></i></button>
					
				  </div>
				  
				</form>
		</div>
		
		<div className="register-and-forgot">
			<a href="#"> <Link to="/forgot_password" onClick={handleForgotPasswordClick}>Forgot Password?</Link></a>
		</div>
		
	</div>
	
// </body>
 
  );



};

export default CoachLogin;